module.exports = __webpack_public_path__ + "img/banner_left.b18c083a.jpg";